module.exports = __webpack_public_path__ + "static/media/Sinergi Apps.2e37f0b7.png";